// extracted by mini-css-extract-plugin
module.exports = {"animatedPreloader":"countLabel_animatedPreloader__1ht_q","countInTab":"countLabel_countInTab__KSZrQ"};